import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  OnInit,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBarRef as MatSnackBarRef, LegacySimpleSnackBar as SimpleSnackBar } from '@angular/material/legacy-snack-bar';
import { AnimationCurves, AnimationDurations } from '@angular/material/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('contentFade', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate(`${AnimationDurations.COMPLEX} ${AnimationCurves.STANDARD_CURVE}`)
      ])
    ])
  ]
})
export class ToastComponent extends SimpleSnackBar implements OnInit {
   @HostBinding('@contentFade') _ = true;
   private className: string;
   icon: string;

   constructor(public snackBarRef: MatSnackBarRef<ToastComponent>, @Inject(MAT_SNACK_BAR_DATA) data: any,
               private elementRef: ElementRef, private renderer: Renderer2) {
      super(snackBarRef, data);
      this.className = 'toast-' + data.type;
      if (data.type === 'error') {
         this.icon = 'error';
      } else if (data.type === 'warn') {
         this.icon = 'warning';
      } else if (data.type === 'success') {
         this.icon = 'check_circle';
      } else {
         this.icon = 'info';
      }
   }

   ngOnInit(): void {
      const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
      this.renderer.addClass(parentNode, this.className);
      this.renderer.addClass(parentNode, 'mat-elevation-z4');
   }
}
